import React, { useState, useEffect } from 'react';
// material
import { withStyles, Theme } from '@material-ui/core/styles';
import TextInput from '../../../components/inputs/CustomTextInput';
import SelectInput from '../../../components/inputs/CustomSelectInput';
import ActionButton from '../../../components/buttons/ActionButton';
import EmptyScreen from "../EmptyPage"
import { CampaignContact } from "../../../entities/site"
import Divider from "../../../components/divider/Divider";
import { DISPOSITIONS } from '../data';

const styles: any = (theme: Theme) => ({
    title: {
      fontSize: "26px",
      fontFamily: "Roboto",
      fontWeight: "500",
      lineHeight: "30px",
      [theme.breakpoints.down('xs')]: {
        fontSize: "20px"
      }
    },
    dateText: {
        fontSize: "16px",
        fontFamily: "Roboto",
        fontWeight: "500",
        lineHeight: "19px",
        color: "#627995",
        marginLeft: "30px",
        "& span":{
          fontWeight:400
        }
    },
    campaignContainer: {
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: "20px",
      alignItems:"center",
      borderBottom:"1px solid #E0E0E0"
    },
    leftContainer:{
      paddingTop:30,
      paddingRight:25,
      maxWidth:"46%",
      width:"inherit"
    },
    rightContainer:{
      paddingTop:30,
      paddingLeft:25,
      borderLeft:"1px solid #E0E0E0",
      maxWidth:575,
      width:"inherit",
      maxHeight:470,
      overflowY:'auto',
      paddingBottom:30
    },
    leftHeaderContainer:{
      display: "flex",
      justifyContent: "space-between",
      alignItems:"center",
      paddingBottom:20
    },
    contactInfo:{
      fontWeight:500,
      fontSize:20,
      fontFamily: "Roboto",
    },
    edit:{
      fontWeight:500,
      fontSize:16,
      fontFamily: "Roboto",
      color:"#00ABCA",
      cursor:"pointer"
    },
    label:{
      fontFamily: "Roboto",
      color:"#627995"
    },
    fieldContainer:{
      display:'flex',
      alignItems:'center',
      justifyContent:'space-between',
      marginBottom:8
    },
    container:{
      maxHeight:500,
      overflowY:'auto'
    },
    field:{
      width:"70%"
    },
    fieldMargin:{
      marginTop:32
    },
    marginBottom:{
      marginBottom:22
    }
  })


interface ContactInfoProps {
  contact: CampaignContact;
  classes: any;
  onClick: (contact: CampaignContact, disposition: string) => void;
}

const  ContactInfo : React.FC<ContactInfoProps>=(props)=> {   
  const { classes, contact } = props;

  const [disposition, setDisposition] = useState<string>('');

  useEffect(() => {
    setDisposition(contact.disposition ?? '');
  }, [contact])

  if(!contact){
    return <EmptyScreen message='You have nothing to view here'/>;
  }

  return (
    <div>
      <div className={classes.leftHeaderContainer}>
        <span className={classes.contactInfo}>Contact Info</span>
        <span className={classes.edit}>EDIT</span>
      </div>
      <div className={classes.fieldContainer}>
        <span className={classes.label}>ID</span>
        <div className={classes.field}>
          <TextInput type="string" result={contact.id} onChange={()=>{console.log("Clicked")}}/>
        </div>
      </div>
      <div className={classes.fieldContainer}>
        <span className={classes.label}>Phone</span>
        <div className={classes.field}>
          <TextInput type="string" result={contact.phoneNumber} onChange={()=>{console.log("Clicked")}}/>
        </div>
      </div>
      <div className={classes.fieldContainer}>
        <span className={classes.label}>Email</span>
        <div className={classes.field}>
          <TextInput type="string" result={contact.email} onChange={()=>{console.log("Clicked")}}/>
        </div>
      </div>
      <div className={classes.fieldContainer}>
        <span className={classes.label}>Address</span>
        <div className={classes.field}>
          <TextInput type="string" multiline result={contact.address} onChange={()=>{console.log("Clicked")}}/>
        </div>
      </div>
      <Divider />
      <div className={`${classes.fieldContainer} ${classes.fieldMargin}`}>
        <span className={classes.label}>Disposition</span>
        <div className={classes.field}>
          <SelectInput value={disposition} fullWidth values={DISPOSITIONS} onChange={(event)=>setDisposition(event.target.value)}/>
        </div>
      </div>
      <ActionButton name="update" onClick={() => props.onClick(contact, disposition)} fullWidth />
      {/* <div className={`${classes.fieldContainer} ${classes.fieldMargin}`}>
        <span className={classes.label}>Disposition</span>
        <div className={classes.field}>
          <SelectInput value="Sent Welcome Email" fullWidth values={DROPDOWN_DATA} onChange={()=>{console.log("Clicked")}}/>
        </div>
      </div>
      <div className={classes.fieldContainer}>
        <span className={classes.label}>First to Claim</span>
        <div className={classes.field}>
          <SelectInput value="Jessica Jones" fullWidth values={DROPDOWN_DATA_1} onChange={()=>{console.log("Clicked")}}/>
        </div>
      </div> */}
    </div>
    )
  }

export default withStyles(styles)(ContactInfo);



// WEBPACK FOOTER //
// ./src/pages/next-action/contactInfo/index.tsx